import { useEffect, useState } from "react";
import { userExperimentsService } from "../services/userExperiments/userExperimentsService";

export const useMetaCampaignsFlag = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFlag = async () => {
      try {
        const response = await userExperimentsService.getExperiments();
        const flag = response.experiments?.meta_campaigns_module;
        setEnabled(flag?.enabled === "true");
      } catch {
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };
    fetchFlag();
  }, []);

  return { enabled, loading };
};
